import { render, staticRenderFns } from "./CrudTableRelationship.vue?vue&type=template&id=6ce3fa19&scoped=true&"
import script from "./CrudTableRelationship.vue?vue&type=script&lang=js&"
export * from "./CrudTableRelationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce3fa19",
  null
  
)

component.options.__file = "CrudTableRelationship.vue"
export default component.exports